var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgZigLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 36,
    viewBox: "0 0 52 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_769_5043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4547 23.5429C48.0403 23.391 46.7696 24.4186 46.6204 25.833C46.3884 28.0209 44.869 29.8221 42.7502 30.4215C40.6313 31.021 38.3965 30.2806 37.0539 28.5347C36.1865 27.4077 34.5677 27.1977 33.4406 28.0651C32.3135 28.9325 32.1008 30.5486 32.971 31.6785C34.9986 34.3139 38.0678 35.7807 41.2722 35.7807C42.2281 35.7807 43.1977 35.6509 44.1535 35.3802C48.311 34.2061 51.2918 30.6729 51.7476 26.3772C51.894 24.9629 50.8691 23.6949 49.4547 23.5429Z",
    fill: "#0050C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.231 9.76921C51.115 9.36036 51.7283 8.46808 51.7283 7.43215C51.7283 6.00947 50.5763 4.85751 49.1509 4.85751H41.4518C35.7694 4.85751 31.145 9.47915 31.145 15.1616C31.145 20.844 35.7694 25.4684 41.4518 25.4684C47.1343 25.4684 51.7587 20.844 51.7587 15.1616C51.7587 13.1864 51.1979 11.3383 50.231 9.76921ZM41.4518 20.3136C38.6093 20.3136 36.2998 18.0014 36.2998 15.1616C36.2998 12.319 38.612 10.0095 41.4518 10.0095C44.2917 10.0095 46.6039 12.3217 46.6039 15.1616C46.6066 18.0042 44.2944 20.3136 41.4518 20.3136Z",
    fill: "#0050C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2662 4.85751H2.81568C1.393 4.85751 0.238281 6.00947 0.238281 7.43491C0.238281 8.86035 1.39024 10.0123 2.81568 10.0123H12.0479L0.995202 21.0705C0.260381 21.8081 0.0393824 22.9159 0.43718 23.88C0.834978 24.8413 1.77422 25.4684 2.81568 25.4684H12.5976C14.0203 25.4684 15.1723 24.3164 15.1723 22.8938C15.1723 21.4711 14.0203 20.3164 12.5976 20.3164H9.03403L20.0867 9.25539C20.8215 8.5178 21.0425 7.41005 20.6447 6.4487C20.2469 5.4846 19.3077 4.85751 18.2662 4.85751Z",
    fill: "#0050C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9959 5.85475C24.5732 5.85475 23.4185 7.00671 23.4185 8.43215V22.891C23.4185 24.3137 24.5704 25.4684 25.9959 25.4684C27.4185 25.4684 28.5733 24.3164 28.5733 22.891V8.43215C28.5705 7.00947 27.4185 5.85475 25.9959 5.85475Z",
    fill: "#0050C3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9959 0.219269C24.5732 0.219269 23.4185 1.37122 23.4185 2.79667C23.4185 4.22211 24.5704 5.37406 25.9959 5.37406C27.4185 5.37406 28.5733 4.21935 28.5733 2.79667C28.5733 1.37399 27.4185 0.219269 25.9959 0.219269Z",
    fill: "#00F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2664 20.3136C16.8437 20.3136 15.689 21.4655 15.689 22.891C15.689 24.3137 16.8409 25.4684 18.2664 25.4684C19.689 25.4684 20.8438 24.3137 20.8438 22.891C20.841 21.4683 19.689 20.3136 18.2664 20.3136Z",
    fill: "#00F0FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_769_5043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51.5232,
    height: 36,
    fill: "white",
    transform: "translate(0.238281)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgZigLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/zig-logo.1e60b025.svg";
export { ForwardRef as ReactComponent };